<template>
  <ProgramaUniversidadLayout :tipo="tipo" />
</template>

<script>
import ProgramaUniversidadLayout from '@/views/pagos/layouts/ProgramaUniversidadLayout.vue';
import { TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS } from '../utils/constantes';

export default {
  name: 'ProgramaUniversidadNacionalLayout',
  components: {
    ProgramaUniversidadLayout,
  },
  data() {
    return {
      tipo: TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS.NACIONAL,
    };
  },
};
</script>